/** Shared by SSR and the browser. Invalid preferences always use the classic theme. */
export const THEME_COOKIE = "spark-theme";
export const THEMES = ["classic", "warm", "dark", "spark-green", "spark-blue", "dark-green", "dark-blue"] as const;
export type Theme = (typeof THEMES)[number];

export const THEME_LABELS: Record<Theme, string> = {
  classic: "Classic", warm: "Light", dark: "Dark",
  "spark-green": "SPARK Green", "spark-blue": "SPARK Blue",
  "dark-green": "Dark Green", "dark-blue": "Dark Blue",
};
export function parseTheme(value: string | null | undefined): Theme {
  return THEMES.includes(value as Theme) ? value as Theme : "classic";
}
